module.exports = __webpack_public_path__ + "media/images/icons/filled/copy-4320d221a48ff2c92cb47f750c1f02a7.svg";